<template>
    <Faq />
</template>
<script>
import Faq from '@/components/Faq.vue';

export default {
    name: 'FaqAdd',
    components: {
        Faq
    },
}
</script>
